import React, { Component } from "react";
import LoginForm from "../login-form";
import RegisterBox from "../register-box";
import { Redirect } from "react-router";
import { isLoggedIn } from "../../../utils/tokenUtils";
import TextViewer from "../../common/editor/text-viewer";

import "./login.css";

class Login extends Component {
  render() {
    return (
      <div className="row no-gutters">
        <TextViewer pageSlug="login"></TextViewer>
        <div className="col-md-6 col-md-offset-2 col-lg-offset-0">
          {isLoggedIn() ? <Redirect to="/" /> : <LoginForm />}
        </div>
        <div className="col-md-6 col-md-offset-2 col-lg-offset-0">
          <RegisterBox />
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/login/login-page/index.jsx